import type { IconProps } from '@magicschool/spellbook/components/Icon';
import { Icon } from '@magicschool/spellbook/components/Icon';
import { Slot } from '@magicschool/spellbook/components/Slot';

export const EditableTextLeadingAdornmentSlot = Slot<IconProps>({
  displayName: 'EditableText.LeadingAdornment',
  renderDefault: ({ name = 'square-dashed', className, size = 'sm', color = 'default', ...props }) => {
    return (
      <Icon data-spellbook-name="editable-text-leading-adornment" name={name} size={size} color={color} className={className} {...props} />
    );
  },
});
